import { render } from "./Overlay3D.vue?vue&type=template&id=30910522&scoped=true"
import script from "./Overlay3D.vue?vue&type=script&lang=js"
export * from "./Overlay3D.vue?vue&type=script&lang=js"

import "./Overlay3D.vue?vue&type=style&index=0&id=30910522&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30910522"]])

export default __exports__